module.exports = __webpack_public_path__ + "media/images/ph-dpo-b2fdf40c690f80281452a3343e5425a8.png";